var _style, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _path4, _path5, _path6, _path7, _defs, _g, _path8, _g2, _path9, _defs2, _g3, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickerCelebratory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175 175",
    style: {
      enableBackground: "new 0 0 175 175"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#214571;}\r\n\t.st1{fill:#F7941D;}\r\n\t.st2{fill:#FDD20E;}\r\n\t.st3{fill:#FECA80;}\r\n\t.st4{fill:#38BAE8;}\r\n\t.st5{clip-path:url(#SVGID_2_);}\r\n\t.st6{fill:#8ED8F6;}\r\n\t.st7{opacity:0.42;fill:#01A1CC;}\r\n\t.st8{fill:#FDE50F;}\r\n\t.st9{clip-path:url(#SVGID_4_);}\r\n\t.st10{opacity:0.22;fill:#F8971D;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,43.8c-4,0-7.3,3.3-7.3,7.3s3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3S92.4,43.8,88.3,43.8z M88.3,55.8 c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8C93.1,53.7,91,55.8,88.3,55.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.5,122c-3.1,0-5.5,2.5-5.5,5.5c0,3.1,2.5,5.5,5.5,5.5c3.1,0,5.5-2.5,5.5-5.5 C170,124.5,167.5,122,164.5,122z M164.5,130.7c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 S166.2,130.7,164.5,130.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.6,68.7c-3.1,0-5.5,2.5-5.5,5.5c0,3.1,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5C17.1,71.2,14.6,68.7,11.6,68.7z  M11.6,77.4c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C14.7,76,13.3,77.4,11.6,77.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 149.2,
    cy: 106.9,
    r: 2.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 164.5,
    cy: 94.9,
    r: 4.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.8,
    cy: 21.2,
    r: 2.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 19.1,
    cy: 97.8,
    r: 4.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 28.3,
    cy: 66.1,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M53.6,34.2L23,156.3c-0.9,2.5,1.2,5.1,3.8,4.7l90-11.1c2.6-0.3,4-3.3,2.6-5.5L60,33.4 C58.3,30.9,54.6,31.3,53.6,34.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.9,33.7c0,0,1.2-9.6,9.4-12.5l0.9,7.3C66.3,28.5,58.5,27.3,55.9,33.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.7,34.9c0,0,2.1-13-14.3-15.5l-3.4,9C38,28.5,54.2,23,55.7,34.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.8,34.8c0,0-7.9-12.9,6.3-28.8l4.6,5.9C67.7,11.9,55.7,19.5,56.8,34.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M53.6,34.2L23,156.3c-0.9,2.5,1.2,5.1,3.8,4.7l90-11.1c2.6-0.3,4-3.3,2.6-5.5L60,33.4 C58.3,30.9,54.6,31.3,53.6,34.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 66.7,
    cy: 56.3,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 74.3,
    cy: 87.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 51.4,
    cy: 105.4,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 99.6,
    cy: 114.4,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 73.1,
    cy: 122,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 42.8,
    cy: 134.3,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 61.7,
    cy: 153.6,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 26.4,
    cy: 156.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 94.5,
    cy: 144.4,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 49,
    cy: 77.7,
    r: 9.5
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.2,157.8L26.8,161c-2.6,0.3-4.7-2.2-3.8-4.7L53.6,34.2c1-2.8,4.8-3.3,6.4-0.8c-0.2,1.1-0.4,2.1-0.6,3.2 c-0.6,2.9-1.2,5.8-1.7,8.7c-0.8,4.2-1.7,8.5-2.5,12.7c-1,5.1-2,10.3-3.1,15.4c-1.1,5.6-2.2,11.1-3.3,16.7 c-1.1,5.5-2.2,11-3.3,16.5c-1,5-2,10-3,15c-0.8,4-1.6,8.1-2.4,12.1c-0.5,2.6-1,5.2-1.6,7.8c-0.5,2.5-0.2,5.5,0.7,8.2 C39.6,151.4,42.2,156.6,53.2,157.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.8,67.5c0,0,3.5-11.2,17.3-12.3l0.4,8.8C135.5,64,127.8,60,117.8,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.8,67.5c0,0,1.6-5.5-10.6-11.1l-2,7.4C105.2,63.9,115.6,62.3,117.8,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.6,69.5c0,0,9.3-20.7-7.6-31.3l-6.2,6.3C103.8,44.4,120.1,52.9,117.6,69.5z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115,67.8l-53.3,87.8c-1.4,2.3,0.1,5.2,2.8,5.4l90.3,8c2.6,0.2,4.6-2.4,3.7-4.9l-37-95.8 C120.3,65.6,116.5,65.2,115,67.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M115,67.8l-53.3,87.8c-1.4,2.3,0.1,5.2,2.8,5.4l90.3,8c2.6,0.2,4.6-2.4,3.7-4.9l-37-95.8 C120.3,65.6,116.5,65.2,115,67.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.6,144.4c0,0,57.4,6.3,84.5-8.3l5.1,19c0,0-55.4,5.8-92.5-5.5L66.6,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,133.5c0,0,54.7-11.7,75.2-28.2l9.6,16.8c0,0-47.9,17.7-86.6,15.5L73.5,133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.8,119c0,0,50.8-23.4,67.1-44.1l13.1,14.3c0,0-42.8,27.8-81,34.3L75.8,119z"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M84.6,162.8l-9.3-0.8l-10.9-1c-2.6-0.2-4.1-3.2-2.8-5.4L115,67.8c1.5-2.5,5.3-2.2,6.4,0.6 c-2.2,4-4.5,7.9-6.7,11.9c-5,8.8-9.9,17.6-14.8,26.4c-5,9.1-10.6,18.1-15.5,27.2c-3.1,5.8-8,13.2-7.3,20.1 C77.6,158.4,80.8,161,84.6,162.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickerCelebratory);
export default __webpack_public_path__ + "static/media/Ticker_Celebratory.ee2c8978feb347ecbbe0b1be694e967d.svg";
export { ForwardRef as ReactComponent };